export default __webpack_public_path__ + "static/media/anima2-2.755dc039.mp4";